import { PlayerDataGQL, PlayersOnTeam } from '../../Api'
import {
  ALL_STAR_POSITION_ORDER,
  WLLASGTeamIds,
  wllAsgTeams,
} from '../../Constant/allStar'
import { ASGTeamIds, asgTeams } from '../../Constant/allStar'

export const ROSTER_POSITION_ORDER: { [key: string]: number } = {
  A: 1,
  M: 2,
  SSDM: 3,
  LSM: 4,
  D: 5,
  FO: 6,
  G: 7,
}

export const getASGTeamColor = (
  value: ASGTeamIds | WLLASGTeamIds,
  isWLL: boolean = false
) => {
  //Value is the team's code
  let team = isWLL
    ? wllAsgTeams.find((team) => team.id === value)
    : asgTeams.find((team) => team.id === value)
  if (!team) return ''
  return team.color
}

export const isPLLASG = (team: ASGTeamIds | WLLASGTeamIds) => {
  return team === 'east' || team === 'west'
}

export const selectPlayersByRosterType = (
  rosterType: string,
  players: PlayerDataGQL[]
) => {
  switch (rosterType) {
    case 'starter':
      return players.filter(
        (pl) =>
          pl.rosterStatus === 'starter' &&
          pl.currentTeam?.injuryStatus !== 'O' &&
          pl.currentTeam?.injuryStatus !== 'IR'
      )
    case 'injured':
      return players.filter((pl) => pl.currentTeam?.injuryStatus === 'O')
    default: //active
      return players.filter(
        (pl) =>
          pl.rosterStatus === 'active' &&
          pl.currentTeam?.injuryStatus !== 'O' &&
          pl.currentTeam?.injuryStatus !== 'IR'
      )
  }
}

export const checkSatisfyTeamCheck = (
  player: PlayersOnTeam,
  selectedPlayers: PlayersOnTeam[],
  totalTeamSize: number = 8
) => {
  if (selectedPlayers.length > totalTeamSize)
    return {
      valid: false,
      text: 'Too many players selected',
    }

  let pos = mergePosition(player.currentTeam?.position)

  const selectedForPosition = selectedPlayers.filter(
    (sel) => mergePosition(sel.currentTeam?.position) === pos
  )
  if ((pos === 'G' || pos === 'FO') && selectedForPosition.length > 0) {
    return {
      valid: false,
      text: `Position ${pos} is already full. Remove a player first`,
    }
  }

  if (selectedForPosition.length > 1) {
    return {
      valid: false,
      text: `Position ${pos} is already full. Remove a player first`,
    }
  }
  return {
    valid: true,
    text: '',
  }
}

export const mergePosition = (pos: string) => {
  if (pos === 'LSM') {
    return 'D'
  }
  if (pos === 'SSDM') {
    return 'M'
  }
  return pos
}

export const checkCanSubmitToday = (lastSubmitDateString: string) => {
  if (!lastSubmitDateString) return true

  const today = new Date().toDateString()
  const canVote = lastSubmitDateString !== today

  return canVote
}

export const sortAllStarOrderByPosition = (
  players: PlayersOnTeam[]
): PlayersOnTeam[] => {
  return players.sort((a, b) => {
    const posA = ALL_STAR_POSITION_ORDER[a.currentTeam.position]
    const posB = ALL_STAR_POSITION_ORDER[b.currentTeam.position]

    // Compare positions based on their order values
    return posA - posB
  })
}

export const sortRosterByPosition = (players: PlayerDataGQL[]): PlayerDataGQL[] => {
  return players.sort((a, b) => {
    const posA = ROSTER_POSITION_ORDER[a.position] || 999
    const posB = ROSTER_POSITION_ORDER[b.position] || 999

    return posA - posB
  })
}
